if ($("#chatapp").length > 0) {
  // Client side Socket.IO object
  var socket = io(SOCKET_URL);

  // Creating a new Vue Instance
  let chatapp = new Vue({
    // Adding a root element to our vue app
    el: "#chatapp",

    // Declaring our data object with empty arrays and properties
    data: {
      newMessage: null,
      typing: null,
      typingTimeout: undefined,
      searchQuery: "",
      isTyping: false,
      searchResult: [],
      isLoadingSearch: false,
      isFocused: false,
      removeSearch: false,
      chats: [],
      connectedChats: [],
      blurTimeout: null,
      activeChat: 0,
      isLoadingMessages: false,
      activeChatMessages: [],
      activeChatPage: 1,
      activeChatTotalPages: 1,
      msgDates: new Set(),
      connected: false,
      connecting: true,
      isChatDropdownOpen: false,
      observer: null,
      infiniteLoading: false,
    },

    // Our vue created method
    created() {
      console.log("chatapp created");

      // Setup Intersection Observer
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          if(this.$refs.scrollContainer.scrollHeight > this.$refs.scrollContainer.clientHeight) {
            console.log('loadMoreMessages');
            this.loadMoreMessages();
          }
        }
      });

      // Emitting 'leave' event on tab closed event.
      window.onbeforeunload = () => {
        //socket.emit("leave", this.username);
      };

      // Listening to chat message event emitted from the server and pushing to messages array
      socket.on("chat message", (data) => {
        console.log("chat message");
        if (data.sender_id != USER_ID && data.chat_id == this.activeChat) {
          fetch(API_URL + "/chat/message/" + data.message_id, {
            headers: {
              "X-API-KEY": TOKEN,
              "Accept-Language": CL,
            },
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.data.chat_id == this.activeChat) {
                this.activeChatMessages.push(data.data);
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            })
            .finally(() => {
              this.isLoadingMessages = false;

              if (data.chat_id == this.activeChat) {
                this.$nextTick(function () {
                  let container = this.$refs.scrollContainer;
                  container.scrollTop = container.scrollHeight + 120;
                });

                if (this.activeChatMessages.length > 0) {
                    this.updateReadStatus(this.activeChat);
                }
              }
            });
        } else if (data.sender_id != USER_ID && data.chat_id != this.activeChat) {
          this.updateChats();
        }
      });

      // Listening to typing event emitted from the server and setting the data (username) to the UI
      socket.on("typing", (data) => {
        if (data.typing) {
          this.typing = data;
        } else {
          this.typing = null;
        }
      });


      socket.on("user joined", (data) => {
        if (data.user_id == USER_ID) {
          this.updateChats();
        }
      });

      // connection to server was lost, blocking the UI
      socket.io.on("close", () => {
        this.connected = false;
        console.log("lost connection");
      });

      // connection to server was re-established, unblocking the UI and rejoining rooms
      socket.io.on("reconnect", () => {
        this.connected = true;
        console.log("reconnected");
      });

      // established connection to server
      socket.on("connect", () => {
        console.log("connected to server");

        // join user room
        socket.emit("user", USER_ID);

        // Fetching all the chats for the side bar
        fetch(API_URL + "/chats", {
          headers: {
            "X-API-KEY": TOKEN,
            "Accept-Language": CL,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
            this.chats = data.data;
            this.connected = true;
            this.connecting = false;  

            if (this.chats.length > 0) {
              this.chats.forEach((chat) => {
                socket.emit("room", chat.id);
                this.connectedChats.push(chat.id);
              });

              // Open chat if $_GET['chat'] is set
              if (GOTO_CHAT > 0) {
                this.openChat(GOTO_CHAT);
              }
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {});
      });

      // Setting up our debounced search function
      this.debouncedSearch = _.debounce(this.searchUsers, 300);
    },

    watch: {
      searchQuery: _.debounce(function () {
        this.isTyping = false;
      }, 1000),
      isTyping: function (value) {
        if (!value) {
          this.searchUser(this.searchQuery);
        }
      },
    },

    computed: {
      orderedChats: function () {
        return _.orderBy(this.chats, "created_at.date", "desc");
      },

      /**
       * Computes the messages to decide if the date heading should be shown.
       *
       * @return {Array} An array of objects containing the original message, the formatted date, and the showDate flag.
       */
      messagesWithDates() {
        const today = dateFns.startOfDay(new Date());
        let lastDate = null;

        return this.activeChatMessages.map((message, index) => {
          const msgDate = dateFns.parseISO(message.sent_at.date);
          const headingDate = this.formatMessageDate(message.sent_at.date);
          const dateToCheck = dateFns.startOfDay(msgDate);

          const showDate = lastDate === null || !dateFns.isSameDay(lastDate, dateToCheck);

          lastDate = dateToCheck;

          /* return {
                ...message,
                headingDate,
                showDate
              }; */

          return Object.assign({}, message, {
            headingDate,
            showDate,
          });
        });
      },
    },

    //Vue Methods hook
    methods: {
      //The send method stores the user message and emit an event to the server.
      send: function () {
        if (!this.newMessage || (this.newMessage && this.newMessage.trim() == "")) {
          swal("Error", LANG_CHAT.please_enter_a_message, "error");
          return;
        }

        fetch(API_URL + "/chat/message", {
          method: "POST",
          headers: {
            "X-API-KEY": TOKEN,
            "Accept-Language": CL,
          },
          body: JSON.stringify({ chat_id: this.activeChat, content: this.newMessage }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status === false) {
              console.log(data.message);
              swal("Error", data.message, "error");

              _.remove(this.chats, {
                id: this.activeChat,
              });
              this.updateChats();
              if(this.chats.length > 0) {
                this.openChat(this.chats[0].id);
              } else {
                this.activeChat = 0;
                this.activeChatMessages = [];
                this.activeChatPage = 1;
                this.activeChatTotalPages = 1;
              }

              return;
            }

            this.activeChatMessages.push(data.data);

            socket.emit("chat message", {
              message_id: data.data.id,
              sender_id: USER_ID,
              chat_id: this.activeChat,
            });

            console.log(data);
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            this.newMessage = null;
          });
      },

      typingStart: function (e) {
        if (e.which != 13) {
          socket.emit("typing", { typing: true, sender_id: USER_ID, chat_id: this.activeChat });
          clearTimeout(this.typingTimeout);
          this.typingTimeout = setTimeout(this.typingStop, 2000);
        } else {
          clearTimeout(this.typingTimeout);
          this.typingStop();
        }
      },

      typingStop: function () {
        socket.emit("typing", { typing: false, sender_id: USER_ID, chat_id: this.activeChat });
      },

      onSearchInput: function () {
        this.debouncedSearch();
      },

      onFocus: function () {
        clearTimeout(this.blurTimeout);
        this.isFocused = true; // Define como verdadeiro quando o input está focus
      },

      onBlur: function () {
        this.blurTimeout = setTimeout(() => {
          this.isFocused = false; // Define como falso quando o input perde o focus
        }, 200);
      },

      updateChats: function () {
        fetch(API_URL + "/chats", {
          headers: {
            "X-API-KEY": TOKEN,
            "Accept-Language": CL,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            this.chats = data.data;

            if (this.chats.length > 0) {
              this.chats.forEach((chat) => {
                socket.emit("room", chat.id);
                this.connectedChats.push(chat.id);
              });
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      },

      /**
       * Searchs users based on the search query and handles the loading state.
       *
       * @return {void} No return value.
       */
      searchUsers: function () {
        if (this.searchQuery.length < 3) {
          this.searchResult = [];
          return;
        }

        this.isLoadingSearch = true;

        fetch(API_URL + "/chats/search?q=" + this.searchQuery, {
          headers: {
            "X-API-KEY": TOKEN,
            "Accept-Language": CL,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            this.searchResult = data.data;
            console.log(this.searchResult);
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            this.isLoadingSearch = false;
          });
      },

      /**
       * Clears the search result, search query, and sets removeSearch to false.
       */
      clearSearchQuery: function () {
        this.searchResult = [];
        this.searchQuery = ""; // Limpa o conteúdo do input
        this.removeSearch = false;
      },

      /**
       * Adds a chat with the given item.
       *
       * @param {Object} item - The item (user) to add to the chat.
       * @return {void}
       */
      addChat: function (item) {
        this.isFocused = false;

        const existingChat = this.chats.find((chat) => chat.members.some((member) => member.id === item.id));

        if (existingChat) {
          this.openChat(existingChat.id);
          this.searchResult = [];
          this.searchQuery = "";
          return;
        }

        fetch(API_URL + "/chat", {
          method: "POST",
          headers: {
            "X-API-KEY": TOKEN,
            "Accept-Language": CL,
          },
          body: JSON.stringify({ user_id: item.id }),
        })
          .then((response) => response.json())
          .then((data) => {
            socket.emit("room", data.data.id); //join room
            socket.emit("user joined", { //notify other user
              user_id: item.id
            });

            this.chats.push(data.data);
            this.connectedChats.push(data.data.id);
            this.openChat(data.data.id);
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            this.searchResult = [];
            this.searchQuery = "";
          });
      },

      /**
       * Sets the active chat and loads chat messages.
       *
       * @param {object} chat - The chat object containing the chat ID.
       */
      openChat: function (chat) {
        this.activeChat = chat;
        this.isLoadingMessages = true;
        this.activeChatPage = 1;
        this.activeChatTotalPages = 1;

        console.log("openChat", chat);

        fetch(API_URL + "/chat/" + chat + "/messages", {
          headers: {
            "X-API-KEY": TOKEN,
            "Accept-Language": CL,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            this.activeChatMessages = data.data;

            if (this.activeChatMessages.length > 0) {
                this.updateReadStatus(this.activeChat);
            }

            this.$nextTick(() => {
              this.observer.observe(this.$refs.sentinel);
            });

            this.activeChatPage++;
            this.activeChatTotalPages = data.pagination.total_pages;
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            this.isLoadingMessages = false;
          });
      },

      /**
       * Formats a chat timestamp into a human-readable date string.
       *
       * @param {string} timestamp - The timestamp to format.
       * @return {string} The formatted date string.
       */
      formatChatDate: function (timestamp) {
        const date = new Date(timestamp);
        const currentDate = new Date();
        const timeDiff = currentDate.getTime() - date.getTime();

        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const oneWeek = 7 * oneDay; // One week in milliseconds

        if (dateFns.isToday(date)) {
          // Today
          return dateFns.format(date, "h:mm a");
        } else if (dateFns.isYesterday(date)) {
          // Yesterday
          return LANG_CHAT.yesterday;
        } else if (timeDiff <= oneWeek) {
          // Less than a week
          return dateFns.format(date, "EEEE");
        } else {
          // More than a week
          return dateFns.format(date, "dd/MM/yyyy");
        }
      },

      /**
       * Formats a message date into a human-readable string.
       *
       * @param {string} timestamp - The date to format in ISO 8601 format.
       * @return {string} The formatted date string.
       */
      formatMessageDate: function (timestamp) {
        const today = dateFns.startOfDay(new Date());
        const msgDate = dateFns.parseISO(timestamp);
        let dateDay = "";

        if (dateFns.isSameDay(msgDate, today)) {
          dateDay = LANG_CHAT.today;
        } else if (dateFns.isYesterday(msgDate)) {
          dateDay = LANG_CHAT.yesterday;
        } else {
          dateDay = dateFns.format(msgDate, "MMMM d, yyyy");
        }

        return dateDay;
      },

      toggleChatDropdown: function () {
        this.isChatDropdownOpen = !this.isChatDropdownOpen;
        window.addEventListener("click", this.closeChatDropdown);
      },

      closeChatDropdown(e) {
        if (!this.$refs.chatDropdown.contains(e.target)) {
          this.isChatDropdownOpen = false;
          window.removeEventListener("click", this.closeChatDropdown);
        }
      },

      deleteChat: function (id) {
        swal({
          title: LANG_CHAT.are_you_sure,
          text: LANG_CHAT.all_the_messages_will_be_deleted,
          showCancelButton: true,
          confirmButtonColor: "#f27474",
          confirmButtonText: LANG_CHAT.delete,
          cancelButtonText: LANG_CHAT.cancel,
        }).then((result) => {
          if (result.value) {
            this.isChatDropdownOpen = false;
            window.removeEventListener("click", this.closeChatDropdown);

            fetch(API_URL + "/chat/" + id, {
              method: "DELETE",
              headers: {
                "X-API-KEY": TOKEN,
                "Accept-Language": CL,
              },
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.status === false) {
                  console.log(data.message);
                  swal("Error", data.message, "error");
                }

                _.remove(this.chats, {
                  id: id,
                });
                this.updateChats();
                if(this.chats.length > 0) {
                  this.openChat(this.chats[0].id);
                } else {
                  this.activeChat = 0;
                  this.activeChatMessages = [];
                  this.activeChatPage = 1;
                  this.activeChatTotalPages = 1;
                }
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          }
        });
      },

      updateReadStatus: function (chat_id) {
        fetch(API_URL + "/chat/message/update-status", {
          method: "POST",
          headers: {
            "X-API-KEY": TOKEN,
            "Accept-Language": CL,
          },
          body: JSON.stringify({ chat_id: chat_id, user_id: USER_ID }),
        })
          .then((response) => response.json())
          .then((data) => {
            this.updateChats();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      },

      loadMoreMessages() {
        if (this.isLoadingMessages) return;

        if (this.activeChatPage > this.activeChatTotalPages) {
          return;
        }
  
        this.isLoadingMessages = true;
        const container = this.$refs.scrollContainer;
        const scrollHeightBefore = container.scrollHeight - 60;
  
        // Fetch more messages
        fetch(API_URL + "/chat/" + this.activeChat + "/messages?page=" + this.activeChatPage, {
          headers: {
            "X-API-KEY": TOKEN,
            "Accept-Language": CL,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            
            this.activeChatMessages = _.concat(data.data, this.activeChatMessages);

            this.activeChatPage++;

            this.$nextTick(() => {
              console.log(container.scrollHeight);
              container.scrollTop = -container.scrollHeight + scrollHeightBefore;
            });
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            this.isLoadingMessages = false;
          });

        
      }
    },
  });
}
